import { Locale } from '../../locale'
import { TelusGlobalElements } from './TelusGlobalElements'
import dynamic from 'next/dynamic'

// Code-split Koodo bundle off TELUS pages; SSR must stay on so <Head> meta and H1 render for SEO (issue #2812). MFE init is gated client-side inside Header/Footer.
const KoodoGlobalElements = dynamic(() =>
  import('./KoodoGlobalElements').then((mod) => ({ default: mod.KoodoGlobalElements }))
)

export type GlobalElementsProps = {
  brand: 'telus' | 'koodo'
  disabled?: boolean
  children: React.ReactNode
  locale?: Locale
}

export function GlobalElements({ children, brand, disabled, locale, ...props }: GlobalElementsProps) {
  if (disabled) {
    return <>{children}</>
  }

  if (brand === 'telus') {
    return <TelusGlobalElements>{children}</TelusGlobalElements>
  }

  if (brand === 'koodo') {
    return <KoodoGlobalElements locale={locale}>{children}</KoodoGlobalElements>
  }
}
